export class GetActionDependsOnValuesDto {
    constructor(public EntityName: string,
                public FieldNames: string[],
                public RecordId: number) {
    }
}